import { tickerItems } from '@/mocks/home';

export default function Ticker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full border-y border-background-200 bg-background-100">
      <div className="flex items-center gap-3 md:gap-5 px-4 md:px-8 py-3">
        <span className="shrink-0 inline-flex items-center gap-1.5 text-xs font-label text-primary-600 whitespace-nowrap">
          <i className="ri-broadcast-line text-sm"></i>
          更新速览
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee gap-8">
            {loop.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="text-xs font-label text-foreground-600 whitespace-nowrap inline-flex items-center gap-2"
              >
                <i className="ri-arrow-right-s-line text-secondary-500"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}